var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2739 4C12.6536 4 12.9674 4.28215 13.0171 4.64823L13.0239 4.75V19.75C13.0239 20.1642 12.6881 20.5 12.2739 20.5C11.8942 20.5 11.5804 20.2178 11.5308 19.8518L11.5239 19.75V4.75C11.5239 4.33579 11.8597 4 12.2739 4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.767 13.171C18.0593 12.8775 18.5342 12.8765 18.8277 13.1687C19.0945 13.4344 19.1196 13.851 18.9024 14.1451L18.83 14.2294L12.806 20.2794C12.5395 20.547 12.1214 20.5714 11.8273 20.3524L11.7431 20.2794L5.71808 14.2294C5.4258 13.9359 5.42678 13.4611 5.72028 13.1688C5.9871 12.9031 6.40381 12.8797 6.69697 13.0982L6.78094 13.171L12.2748 18.687L17.767 13.171Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.186358d0cc6e8a77e01a88890145894f.svg";
export { ForwardRef as ReactComponent };